__turbopack_context__.v({
  "arrow": "product-gallery-module-scss-module__PdntRG__arrow",
  "close": "product-gallery-module-scss-module__PdntRG__close",
  "counter": "product-gallery-module-scss-module__PdntRG__counter",
  "frame": "product-gallery-module-scss-module__PdntRG__frame",
  "play": "product-gallery-module-scss-module__PdntRG__play",
  "root": "product-gallery-module-scss-module__PdntRG__root",
  "slide": "product-gallery-module-scss-module__PdntRG__slide",
  "stage": "product-gallery-module-scss-module__PdntRG__stage",
  "thumb": "product-gallery-module-scss-module__PdntRG__thumb",
  "thumbs": "product-gallery-module-scss-module__PdntRG__thumbs",
  "tile": "product-gallery-module-scss-module__PdntRG__tile",
  "track": "product-gallery-module-scss-module__PdntRG__track",
  "video": "product-gallery-module-scss-module__PdntRG__video",
  "zoom": "product-gallery-module-scss-module__PdntRG__zoom",
  "zoom-body": "product-gallery-module-scss-module__PdntRG__zoom-body",
  "zoom-frame": "product-gallery-module-scss-module__PdntRG__zoom-frame",
  "zoom-head": "product-gallery-module-scss-module__PdntRG__zoom-head",
  "zoom-stage": "product-gallery-module-scss-module__PdntRG__zoom-stage",
});
